function SwatchesConstructor(obj_json, obj_param){
  var _ = this;

  _.show_unavailable_options = obj_param['show_unavailable_options'] || false;
  
  _.productIsValid = _.show_unavailable_options || obj_json.available;
  _.product_json = obj_json;
  _.options_name = '';
  _.options = '';

  _.viewDesign = window['viewButtons'];

  _.designOption1 = obj_param['designOption1'] || 'getButtonHtml';
  _.designOption2 = obj_param['designOption2'] || 'getButtonHtml';
  _.designOption3 = obj_param['designOption3'] || 'getButtonHtml';
  
  _.contentParent = obj_param['contentParent'];
  _.enableHistoryState = Boolean(obj_param['enableHistoryState']) || false;
  _.callback = obj_param['callback'] || false;
  _.texture_obj = obj_param['externalImagesObject'] || {};
  _.colors_obj = obj_param['externalColors'] || {};
  _.color_with_border = obj_param['colorWithBorder'] || {};
  
  _.product_handle = obj_param['productHandle'] || {};

  _.selectedByDefault = obj_param['selectedByDefault'] === undefined ? true : obj_param['selectedByDefault'];
  (_.productIsValid && obj_json.options != 'Title') && $(_.contentParent).length ? _.initSwatches() : _.callExternalVariantHandler(_.callback, obj_json.variants[0], _.getJsonObject());
}

SwatchesConstructor.prototype.destroy = function() {
  var $parent = $(this.contentParent);
  $parent.find('a').unbind();
  $parent.find('select').unbind();
  $parent.empty();
}

SwatchesConstructor.prototype.initSwatches = function() {
  var _ = this;
  var arr = [];
  var options_object = false;
  
  options_object = _.getJsonObject().options;
  for(var i = 0; i<options_object.length; i++){
    arr[i] = Object(options_object[i]).name;
  }
  _.options_name = arr;
  
  _.options = getAllOptions(_.getJsonObject().variants, _.show_unavailable_options);
  var variant_id = _.enableHistoryState && getVariantIdUrl();
  _.createSwatches(variant_id);
}
SwatchesConstructor.prototype.createSwatches = function(variant_id) {
  var _ = this;
  var fn = _.viewDesign;

  if (isEmpty(_.options)) return false;
  var variant = getCurrentVariantById(_.getJsonObject().variants, variant_id, _.show_unavailable_options);
  var selected_variant_array = getCurrentOptionsArray(variant);
  _.createOptionsView(_.contentParent, _.options, _.options_name, selected_variant_array);
  _[fn('getFunctionClickHandler')]();

  _.callExternalVariantHandler(_.callback, variant, _.getJsonObject());
  _.selectedByDefault = true;
}
/* Handlers */
SwatchesConstructor.prototype.buttonHandler = function() {
  var _ = this;
  var fn = _.viewDesign;

  var $_parent = $(_.contentParent);
  var group_parent_name = fn('getGroupElementName');
  var $_group_parent = $_parent.find(group_parent_name);
  
  $_group_parent.find('a').click(function(e){
    e.preventDefault();
    buttonHandler($(this));    
  });
  $_group_parent.find('select').change(function(){
    buttonHandler($(this));
  })

  if(!_.selectedByDefault){
    $_group_parent.find('select').focusin(function(e){
      buttonHandler($(this));
    });
  }
  
  function buttonHandler(_this){
    var localName = _this[0].localName;

    if(localName === 'a') {
      if(_this.hasClass('active')) return false;

      if($_parent.find('.active').length == 0){
        $_group_parent.each(function(){
          $(this).find('ul').find('li').first().addClass('active');        
        })
      }

      $_group_parent.find('a').unbind();
      _this.closest(group_parent_name).find('.active').removeClass('active');
      _this.parent().addClass('active');
    }
    else{
      _this.unbind('focusin');
    }

    var str = '';
    $_group_parent.each(function(){
      if($(this).find('.active').length){
        str += $(this).find('.active').find('[data-value]').data('value') + ' / ';
      }
      else{
        str += $(this).find('select option:selected').text() + ' / ';
      }
    });
    
    _.endOfTheClickHandler(str);
  }
}
SwatchesConstructor.prototype.endOfTheClickHandler = function(str) {
  var _ = this;
  str = str.substring(0, str.length-3);
  var variant = getCurrentVariantByTitle(_.getJsonObject().variants, str, _.show_unavailable_options);
  _.enableHistoryState && history.pushState(null, null, location.pathname+'?variant='+variant.id);
  _.createSwatches(variant.id);
  $(_.contentParent).closest('.tt-product-single-info').find('.input_variant').val(variant.id);
}
/* View */
SwatchesConstructor.prototype.createOptionsView = function(contentParent, value, names, selected){
  var _ = this;
  var fn = _.viewDesign;

  var $_parent = $(contentParent).empty(),
      texture = _.texture_obj,
      colors = _.colors_obj,
      c_border = _.color_with_border,
      opt1 = '',
      opt2 = '',
      opt3 = '',
      button_key = [_.designOption1,_.designOption2,_.designOption3],
      producthandle = _.product_handle,
  	  selectedByDefault = _.selectedByDefault,
      av = false;

  $.each(value, function(key, val){
    if(key == selected[0] && typeof value[key] === 'object' && key != 'Default Title' && key.indexOf('_|av') == -1) {
      var array_options2 = value[key];
      $.each(array_options2, function(key, val){
        if(key == selected[1] && typeof array_options2[key] === 'object' && key.indexOf('_|av') == -1) {
          $.each(array_options2[key], function(key, val){
            opt3 += fn(button_key[2], {avaibility:val, value:key, selected:selected[2], title:names[2], texture:texture, colors:colors, c_border:c_border, producthandle:producthandle, selectedByDefault: selectedByDefault });
          });
        }
        if(key.indexOf('_|av') == -1){
          av = typeof array_options2[key] === 'object' ? array_options2[key+'_|av'] : val;
          opt2 += fn(button_key[1], {avaibility:av, value:key, selected:selected[1], title:names[1], texture:texture, colors:colors, c_border:c_border, producthandle:producthandle, selectedByDefault: selectedByDefault });
        }
        
      });
    }
    if(key != 'Default Title' && key.indexOf('_|av') == -1){
      av = typeof value[key] === 'object' ? value[key+'_|av'] : val;
      opt1 += fn(button_key[0], {avaibility:av, value:key, selected:selected[0], title:names[0], texture:texture, colors:colors, c_border:c_border, producthandle:producthandle, selectedByDefault: selectedByDefault });
    }
  });

  var titles = [names[0], names[1], names[2]];
  var values = [opt1, opt2, opt3];
  for(var i=0; i<values.length; i++) {
    values[i] != '' && $_parent.append(fn(button_key[i].indexOf('getSelect') > -1 ? 'getSelectGroupHtml' : 'getGroupHtml', { title:titles[i], html:values[i] }));
  }
  
  fn('showSelectedParametres');
}
SwatchesConstructor.prototype.getJsonObject = function() {
  return this.product_json;
}
SwatchesConstructor.prototype.callExternalVariantHandler = function(fn, param1, param2) {
  fn && typeof(fn) === "function" && fn(param1, param2);
}


/* Public Methods */
function getAllOptions(data, show_unavailable_options){
  var available = true;
  var obj = {};
  
  for (var i = 0; i < data.length; i++) {
    available = show_unavailable_options ? true : Boolean(data[i].available);
    var opt1 = data[i].option1;
    var opt2 = data[i].option2;
    var opt3 = data[i].option3;
    
    if(opt1 != null && available) {
      if(opt2 != null) {
        obj[opt1] = obj[opt1] || {};
        if(opt3 != null) {
          obj[opt1][opt2] = obj[opt1][opt2] || {};
          obj[opt1][opt2][opt3] = show_unavailable_options ? Boolean(data[i].available) : true;
        }
        else {
          obj[opt1][opt2] = show_unavailable_options ? Boolean(data[i].available) : true;
        }
      }
      else {
        obj[opt1] = show_unavailable_options ? Boolean(data[i].available) : true;
      }
    }
  }
  
  var avaibility = false;
  $.each(obj, function(key, val){
    opt1 = key;
    if(typeof obj[key] === 'object' && key != 'Default Title') {
      var array_options2 = obj[key];
      $.each(array_options2, function(key, val){
        opt2 = key;
        avaibility = false;
        if(typeof array_options2[key] === 'object') {
          $.each(array_options2[key], function(key, val){
            if(!avaibility) avaibility = avaibility || val;
          });
          obj[opt1][opt2+'_|av'] = avaibility;
        }
      });

      avaibility = false;
      $.each(array_options2, function(key, val){
        var v = val;
        if(hasOwnProperty.call(array_options2, key+'_|av') || key.indexOf('_|av') > -1){
          v = key.indexOf('_|av') > -1 ? array_options2[key] : false;
        }
        if(!avaibility){
          avaibility = avaibility || v;
        }
      });
      obj[opt1+'_|av'] = avaibility;
    }
  });
  return obj;
}
function getCurrentOptionsArray(variant){
  var arr = variant.option1 + '%%' + variant.option2 + '%%' + variant.option3;
  arr = arr.replace(/\%\%null/g, '').split('%%');
  return arr;
}

function getCurrentVariantById(data, idToLookFor, show_unavailable_options) {
  for (var i = 0; i < data.length; i++) {
    var available = show_unavailable_options ? true : data[i].available;
    if(!idToLookFor) {
      if (available) return(data[i]);
    } else {
      if (data[i].id == idToLookFor) return(data[i]);
    }
  }
  return(data[0]);
}
function getCurrentVariantByTitle(data, TitleToLookFor, show_unavailable_options) {
  if(!TitleToLookFor) return data[0];

  var variant_fonded = true;

  top:
  for (var i = 0; i < data.length; i++) {
    var d = '%%' + data[i].title;
    var available = show_unavailable_options ? true : data[i].available;
    if (d.indexOf('%%'+TitleToLookFor) > -1 && available && !variant_fonded) return(data[i]);
    if (data[i].title === TitleToLookFor && available && variant_fonded) return(data[i]);
    if(i == data.length-1) {
      if(TitleToLookFor.indexOf('/') > -1){
        TitleToLookFor = TitleToLookFor.split('/');
        TitleToLookFor.pop();
        TitleToLookFor = TitleToLookFor.length > 1 ? TitleToLookFor.join('/') : TitleToLookFor;
        i = 0;
        variant_fonded = false;
        continue top;
      }
    }
  }
  return(data[0]);
}

function getVariantIdUrl(){
  var path_search = location.search;
  if(path_search.indexOf('variant=') > -1) {
    path_search = path_search.match(/variant=\d+/g);
    path_search = parseInt(path_search[0].match(/\d+/g));
  }
  return path_search
}

function isEmpty(obj) {
  return Object.keys(obj).length === 0;
}



/* View */
/*
*<div class=".wrapper">
*	<div class="title-options">title</div>
*	<ul class="tags-list">
*		<li><a href="#" data-value="value">value</a></li>
*	</ul>
*</div>
*/
function viewButtons(type, obj) {
  obj = obj || {};
  var mainElementName = '.wrapper';
  var selectedByDefault = obj.selectedByDefault;
  var avaibility = obj.avaibility === undefined ? true : obj.avaibility;

  switch(type) {
    case 'getFunctionClickHandler':
      return 'buttonHandler';

    case 'getGroupElementName':
      return mainElementName;

      
    case 'getGroupHtml':
      var elementName = mainElementName.replace(/([\.#])/g, ''),
          title_html = '<div class="title-options text-uppercase">'+obj.title+': <span class="current_option_name"></span></div>',
          value_html = obj.html;

      return '<div class="'+elementName+'">'+title_html+'<ul class="options options-large">'+value_html+'</ul></div>';
      
    case 'getButtonHtml':      
      var value = obj.value.trim();
      var color = value.toLowerCase();
      var border = obj.c_border.indexOf(value) > -1 ? ' border' : '';
	  var currenthandle = obj.producthandle;

      color = ',' + color + ':';
      color = obj.colors.indexOf(color) > -1 ? obj.colors.split(color).pop().split(',').shift().trim() : false;
      var style = value in obj.texture ? ' data-optionimage="true" style="background-image:url('+obj.texture[value]+')"' : '';
      if((currenthandle + ' ' + value) in obj.texture) style = ' data-optionimage="true" style="background-image:url('+obj.texture[currenthandle + ' ' + value]+')"';

      if(style == '' && color) style = ' style="background:' + color + ';"';

      var opt_img = ' class="options-color-image"';
      var span = avaibility ? '' : '<span'+opt_img+'></span>';
      var datavalue = value.indexOf('"') > -1 ? "'"+value+"'" : '"'+value+'"';
      avaibility = avaibility ? '' : ' data-availability="false"';
      var btn = style != '' ?
          '<li'+avaibility+'>'+span+'<a href="#" class="options-color' + border + '" data-value="'+value+'" title="'+value+'" '+style+'></a></li>':
      	  '<li'+avaibility+'><a href="#" data-value='+datavalue+' title='+datavalue+'>'+value+'</a></li>';
      if(obj.value != obj.selected || !selectedByDefault) return btn;
      return btn.replace(/<li/, '<li class="active"');
 
    case 'getSelectGroupHtml':
      var elementName = mainElementName.replace(/([\.#])/g, ''),
          title_html = '<div class="title-options text-uppercase">'+obj.title+': <span class="current_option_name"></span></div>',
          value_html = obj.html;
      return '<div class="'+elementName+'">'+title_html+'<select class="form-control select-inline">'+value_html+'</select></div>';

    case 'getSelectButtonHtml':
      var btn = '<option>'+obj.value.trim()+'</option>';
      if(obj.value != obj.selected || !selectedByDefault) return btn;
      return btn.replace(/<option/, '<option selected');
      
    case 'showSelectedParametres':
      if($(mainElementName).find('.active').length == 0) return false;
      $(mainElementName).find('.active').each(function(){
        var d = $(this).find('[data-value]').data('value');
        $(this).closest(mainElementName).find('.current_option_name').text(d);
      });
      return false;
  }
}